/* Feinwunder product page (owner 04/10, item 3 — phones, visitors from Instagram ads)
 * a) sticky bar button reads „In den Warenkorb – 34,99 €“; the bar hides while the keyboard is open (typing in a field)
 * (e) default variant = main photo: done server-side at the top of sections/product-information.liquid
 */
(function () {
  'use strict';
  var phone = function () { return window.matchMedia('(max-width: 749px)').matches; };

  function labelSticky() {
    var bar = document.querySelector('.sticky-add-to-cart__bar');
    if (!bar) return;
    var btn = bar.querySelector('.sticky-add-to-cart__button');
    var span = bar.querySelector('.add-to-cart-text__content > span');
    var price = bar.querySelector('.sticky-add-to-cart__price .price');
    if (!btn || !span || !price || btn.disabled) return;
    var p = price.textContent.replace(/\s+/g, ' ').trim();
    var want = 'In den Warenkorb – ' + p;
    if (p && span.textContent.trim() !== want) span.textContent = want;
  }

  function init() {
    labelSticky();
    var bar = document.querySelector('.sticky-add-to-cart__bar');
    if (bar && window.MutationObserver) {
      new MutationObserver(function () { window.requestAnimationFrame(labelSticky); }).observe(bar, { childList: true, subtree: true, characterData: true });
    }
    // keyboard open → hide the sticky bar so it never covers the field being typed in
    var sticky = document.querySelector('sticky-add-to-cart');
    var typing = function (el) { return el && el.matches && el.matches('input:not([type=radio]):not([type=checkbox]):not([type=button]):not([type=submit]):not([type=file]), textarea, select'); };
    // CRO 28.10 (audit point 7): while a field is focused on a phone (in-app browsers included) the page itself gets
    // html.fw-typing → assets/fw-theme.css hides the small picture bar and lets the header scroll away (it no longer sticks)
    // — before: header ~55 + picture bar ~110 + buy bar ~75 px ≈ 36 % of a 659-px in-app screen over the field.
    document.addEventListener('focusin', function (e) {
      if (!phone() || !typing(e.target)) return;
      if (sticky) sticky.classList.add('fw-typing');
      document.documentElement.classList.add('fw-typing');
    });
    document.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (typing(document.activeElement)) return;
        if (sticky) sticky.classList.remove('fw-typing');
        document.documentElement.classList.remove('fw-typing');
      }, 150);
    });
    watchAdd();
  }

  // CRO 28.10 (audit point 8): a tap on „In den Warenkorb“ must ALWAYS give a visible answer. The theme stays silent when a
  // choice is still loading or the button is busy, and a rare in-app case (1 of 8 tries 28/10) added nothing without a word.
  // 1.6 s after the tap: no drawer, no error under a field, no theme error, no „added“ → short message above the buy bar.
  // Reads only the page, sends nothing.
  function watchAdd() {
    var last = 0, added = 0;
    document.addEventListener('fw:added', function () { added = Date.now(); });
    function visible(el) { return !!(el && !el.hidden && !el.closest('[hidden]') && el.getClientRects().length && getComputedStyle(el).display !== 'none'); }
    function answered(t0) {
      if (added >= t0) return true;
      if (document.querySelector('dialog[open], dialog.fw-adding, .fw-atc-toast:not([hidden])')) return true;
      var signs = document.querySelectorAll('.fw-field-error, .fw-up__status--err, .fw-up__status--busy, .fw-pers__wait, .product-form-text__error:not(.hidden)');
      for (var i = 0; i < signs.length; i++) if (visible(signs[i]) && (signs[i].textContent || '').trim()) return true;
      return false;
    }
    function say() {
      var en = (document.documentElement.lang || '').slice(0, 2) === 'en';
      var box = document.querySelector('.fw-atc-warn');
      if (!box) {
        box = document.createElement('p');
        box.className = 'fw-atc-warn';
        box.setAttribute('role', 'alert');
        document.body.appendChild(box);
      }
      box.textContent = en ? 'That did not work – please tap „Add to cart“ once more.'
        : 'Das hat gerade nicht geklappt – bitte tippe noch einmal auf „In den Warenkorb“.';
      box.hidden = false;
      clearTimeout(box.__t);
      box.__t = setTimeout(function () { box.hidden = true; }, 8000);
    }
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('add-to-cart-component button, .sticky-add-to-cart__button');
      if (!b || b.closest('dialog')) return;
      var t0 = Date.now();
      if (t0 - last < 400) return;                    // the sticky button clicks the main one → count the tap once
      last = t0;
      var w = document.querySelector('.fw-atc-warn');
      if (w) w.hidden = true;
      setTimeout(function () { if (!answered(t0)) say(); }, 1600);
    }, true);
  }
  // (e) default variant = main photo: OFF since 05/10 (see sections/product-information.liquid)
  function start() { init(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
